const HUBSPOT_EMBED_SRC = "https://js.hsforms.net/forms/embed/7476704.js";

const loadHubSpot = () => {
    if (document.querySelector(`script[src="${HUBSPOT_EMBED_SRC}"]`)) {
        return;
    }
    const script = document.createElement("script");
    script.src = HUBSPOT_EMBED_SRC;
    script.defer = true;
    document.body.appendChild(script);
};

export default () => {

    const form = document.querySelector('[data-subscribe]');
    const popup = document.querySelector('.js-newsletter-popup');

    if (!form || !popup) {
        return;
    }

    const closeBtn = popup.querySelector('.js-newsletter-popup-close');
    const formWrap = popup.querySelector('.newsletter-popup__form');
    const template = popup.querySelector('.js-hs-form-template');

    let frame = null;

    const mountFrame = () => {
        if (frame || !template || !formWrap) {
            return;
        }
        frame = template.content.firstElementChild.cloneNode(true);
        formWrap.appendChild(frame);
    };

    const isFormRendered = () => !!(frame && frame.querySelector('iframe, form'));

    let warmed = false;
    const warmHubSpot = () => {
        if (warmed) {
            return;
        }
        warmed = true;
        loadHubSpot();
    };
    form.addEventListener('pointerenter', warmHubSpot, { once: true });
    form.addEventListener('focusin', warmHubSpot, { once: true });

    let loaderWatching = false;

    const showFormLoader = () => {
        if (!formWrap || !frame) {
            return;
        }

        if (isFormRendered()) {
            formWrap.classList.remove('is-loading');
            return;
        }

        formWrap.classList.add('is-loading');

        if (loaderWatching) {
            return;
        }
        loaderWatching = true;

        const startedAt = Date.now();
        const MIN_VISIBLE = 800;
        let settled = false;
        let failSafe;

        const hide = () => formWrap.classList.remove('is-loading');

        const cleanup = () => {
            window.removeEventListener('message', onMessage);
            window.removeEventListener('hs-form-event:on-ready', settle);
            window.removeEventListener('hs-form-event:on-render', settle);
            observer.disconnect();
            window.clearTimeout(failSafe);
            loaderWatching = false;
        };

        const settle = () => {
            if (settled) {
                return;
            }
            settled = true;
            const wait = Math.max(0, MIN_VISIBLE - (Date.now() - startedAt));
            window.setTimeout(hide, wait);
            cleanup();
        };

        const onMessage = (e) => {
            const d = e.data;
            if (
                d &&
                d.type === 'hsFormCallback' &&
                (d.eventName === 'onFormReady' || d.eventName === 'onFormDefinitionFetchSuccess')
            ) {
                settle();
            }
        };

        const observer = new MutationObserver(() => {
            if (isFormRendered()) {
                settle();
            }
        });

        window.addEventListener('message', onMessage);
        window.addEventListener('hs-form-event:on-ready', settle);
        window.addEventListener('hs-form-event:on-render', settle);
        observer.observe(frame, { childList: true, subtree: true });

        failSafe = window.setTimeout(() => {
            hide();
            cleanup();
        }, 12000);

        if (isFormRendered()) {
            settle();
        }
    };

    const closePopup = () => {
        popup.classList.remove('is-active');
        document.body.classList.remove('newsletter-popup-open');
    };

    const openPopup = () => {
        loadHubSpot();
        popup.classList.add('is-active');
        document.body.classList.add('newsletter-popup-open');
        mountFrame();
        showFormLoader();
    };

    form.addEventListener('submit', (e) => {
        e.preventDefault();

        if (typeof form.reportValidity === 'function' && !form.reportValidity()) {
            return;
        }

        openPopup();
    });

    if (closeBtn) {
        closeBtn.addEventListener('click', closePopup);
    }

    popup.addEventListener('click', (e) => {
        if (e.target === popup) {
            closePopup();
        }
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && popup.classList.contains('is-active')) {
            closePopup();
        }
    });

};
